import * as d3 from 'd3';
import { processDateSeriesCsvData, scaled } from '../utils';
import lineChart from '../utils/line-chart';
import { DEFAULT_CHART_WIDTH } from '../constants';

export default function() {
  // required parameters
  let data;
  let primaryLineColor;
  let chartId;

  // optional parameters
  let primaryCountry = 'Ireland';

  // constants
  const height = scaled(400, width);
  const padding = [20, 20, 20, 40];

  const chart = function(selection) {
    selection.each(function() {
      const container = d3.select(this);

      const [lines, dates] = processDateSeriesCsvData(data, ['location']);

      let timer, tooltip;

      container.attr('id', chartId)
        .attr('class', 'chart international-line');

      container.append('svg')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .datum({lines, dates})
        .call(lineChart()
          .width(width)
          .height(height)
          .padding(padding)
          .strokeAccessor(function(d, i) {
            if (d.location === primaryCountry) {
              return primaryLineColor
            }
            const hue = Math.floor((360 / (lines.length - 1)) * i);
            return d3.hsl(hue, 0.5, 0.85)
          })
          .strokeWidthAccessor(function(d) {
            if (d.location === primaryCountry) {
              return 4
            }
            return 2
          })
          .mouseOverAccessor(function(event, d) {
            if (timer) {
              window.clearTimeout(timer);
            }
            const position = d3.pointer(event, container.node())
            tooltip.attr('style', `display:block; left: ${position[0] + 10}px; top: ${position[1]}px`);
            tooltip.node().innerHTML = d.location
          })
          .mouseOutAccessor(function() {
            timer = window.setTimeout(function() {
              tooltip.attr('style', 'display:none')
            }, 300)
          })
          .frontLineAccessor(d => d.location === primaryCountry));

      tooltip = container.append('div')
        .attr('class', 'tooltip')
    });
  };

  chart.data = function(_) {
    if (!arguments.length) return data;
    data = _;
    return chart;
  };

  chart.primaryLineColor = function(_) {
    if (!arguments.length) return primaryLineColor;
    primaryLineColor = _;
    return chart;
  };

  chart.chartId = function(_) {
    if (!arguments.length) return chartId;
    chartId = _;
    return chart;
  };

  chart.primaryCountry = function(_) {
    if (!arguments.length) return primaryCountry;
    primaryCountry = _;
    return chart;
  };

  return chart;
}
